import { configureStore, ThunkAction, Action, getDefaultMiddleware } from '@reduxjs/toolkit';
import { reducer as OIDCReducer } from 'redux-oidc';
import userReducer from '../features/authorization/userSlice';

import pricingReducer from '../features/pricing/pricingSlice';
import translationReducer from '../features/translation/translationSlice';
import filterReducer from '../features/filter/filterSlice';
import resultReducer from '../features/result/resultsSlice';
import authorizationReducer from '../features/authorization/authorizationSlice';
export const store = configureStore({
  reducer: {
    translation: translationReducer,
    filter: filterReducer,
    result: resultReducer,
    user: userReducer,
    authConfiguration: authorizationReducer,
    oidc: OIDCReducer,
    pricing: pricingReducer,
  },
  middleware: (middleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
